
export class LinesInUnitModel {
    lineId: string;
    lineDesc: string;

    constructor(lineId: string, lineDesc: string) {
        this.lineId = lineId;
        this.lineDesc = lineDesc;
    }
}